import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Form, Spinner } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import ServiceResultForm from './ServiceResultForm'

import { updateServiceResult } from '../services'
import { handleError } from '../../../helpers'

export default function EditServiceResultModal({ visible, onClose, serviceResult, reload, editable = {} }) {
	const { handleSubmit, register, formState: { errors } } = useForm({ 
		defaultValues: serviceResult
	})
	const [loading, setLoading] = useState(false)

	const onSubmit = values => {
		setLoading(true)
		delete values.sku
		updateServiceResult(serviceResult.id, values)
			.then(res => {
				message.success(res.data.message)
				reload()
				onClose()
			})
			.catch(error => handleError(error, setLoading))
	}

	return (
		<Modal isOpen={visible} toggle={onClose}>
			<ModalHeader toggle={onClose}>Actualizar Registro</ModalHeader>
			<ModalBody>
				<Form onSubmit={handleSubmit(onSubmit)}>
					<ServiceResultForm 
						register={register}
						errors={errors}
						editable={editable}
						serviceResult={serviceResult}
					/>
					<Button color='primary' type="submit" disabled={loading}>
						{ loading && <Spinner animation="border" size="sm" className='mr-1' /> }
						Actualizar Registro
					</Button>
				</Form>
			</ModalBody>
		</Modal>
	)
}